import { useEffect } from "react";

const SITE = "https://morningsundayteerresult.in";

// Sets a unique title, meta description, canonical, robots directive and
// (optionally) BreadcrumbList structured data per page.
export default function useSeo(title, description, options = {}) {
  const { robots = "index, follow", breadcrumb = null } = options;
  const crumbKey = JSON.stringify(breadcrumb);

  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (name, content, attr = "name") => {
      if (!content) return;
      let m = document.querySelector(`meta[${attr}="${name}"]`);
      if (!m) {
        m = document.createElement("meta");
        m.setAttribute(attr, name);
        document.head.appendChild(m);
      }
      m.setAttribute("content", content);
    };

    if (description) {
      setMeta("description", description);
      setMeta("og:description", description, "property");
      setMeta("twitter:description", description);
    }
    if (title) {
      setMeta("og:title", title, "property");
      setMeta("twitter:title", title);
    }
    setMeta("robots", robots);

    // canonical + og:url in sync with current path
    let path = "/";
    try {
      path = window.location.pathname || "/";
    } catch (e) {}
    const url = SITE + (path === "/" ? "/" : path);

    let c = document.querySelector('link[rel="canonical"]');
    if (!c) {
      c = document.createElement("link");
      c.setAttribute("rel", "canonical");
      document.head.appendChild(c);
    }
    c.setAttribute("href", url);
    setMeta("og:url", url, "property");

    // Optional BreadcrumbList JSON-LD
    const existing = document.getElementById("ld-breadcrumb");
    if (breadcrumb && breadcrumb.length) {
      const data = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: breadcrumb.map((b, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: b.name,
          item: SITE + b.path,
        })),
      };
      let s = existing;
      if (!s) {
        s = document.createElement("script");
        s.type = "application/ld+json";
        s.id = "ld-breadcrumb";
        document.head.appendChild(s);
      }
      s.textContent = JSON.stringify(data);
    } else if (existing) {
      existing.remove();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, robots, crumbKey]);
}
